import { render, staticRenderFns } from "./StudentActivityTablePublishStateCell.vue?vue&type=template&id=cb478be8&scoped=true&"
import script from "./StudentActivityTablePublishStateCell.vue?vue&type=script&lang=ts&"
export * from "./StudentActivityTablePublishStateCell.vue?vue&type=script&lang=ts&"
import style0 from "./StudentActivityTablePublishStateCell.vue?vue&type=style&index=0&id=cb478be8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb478be8",
  null
  
)

export default component.exports